import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcLocationFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.75a8.25 8.25 0 0 1 7.561 11.55l-.01.023c-.777 1.626-1.898 3.134-3.072 4.552-.589.71-1.2 1.408-1.791 2.087a74 74 0 0 0-1.706 2.007 1.267 1.267 0 0 1-1.963.003A66 66 0 0 0 9.31 19.99c-.6-.678-1.226-1.38-1.826-2.097-1.195-1.43-2.335-2.964-3.047-4.592A8.25 8.25 0 0 1 12 1.75M12 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
    clipRule: "evenodd"
  }));
}
var IcLocationFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLocationFill));

export { IcLocationFill as I };
